import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/node_modules/next/dist/client/link.js");
